import { Reducer } from 'interfaces'
import { AdvisorDataState } from 'components/features/coaching/advisorStore/interfaces/state'
import { GetPublicAdvisorAction } from 'components/features/coaching/advisorStore/actions/publicAdvisorActions'


export const usernameToUidReducer: Reducer<AdvisorDataState['usernameToUid']> = (prevState = {}, action) => {
  switch (action.type) {
    case GetPublicAdvisorAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      const { uid } = action.payload.response
      const { username } = action.payload.params
      return {
        ...prevState,
        [username]: uid,
      }
    }
  }
  return prevState
}
